import React from 'react'
import { Separator, MarginBox } from '@fs/zion-ui'
import { UserPortraitSelector } from '@fs/zion-portrait-selector'
import { number, string, func, bool, oneOfType } from 'prop-types'
import { useTranslation } from 'react-i18next'
import WideToggle from '../WideToggle/WideToggle'
import PointsNStreakRow from '../PointsNStreakRow'

export default function SmallStoryHeaderContent({
  onActivePersonIdChange,
  streakCount,
  points,
  isStreakCurrent,
  onStreakClick,
  onPointsClick,
  activePersonId,
  cisId,
}) {
  const { t, i18n } = useTranslation()
  const showTallHeader = !activePersonId

  return (
    <div style={{ position: 'relative', width: '100%', height: showTallHeader ? '280px' : '50px', marginTop: '10px' }}>
      <MarginBox marginX="sm" style={{ width: '100%', maxWidth: '500px' }} />
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <div style={{ width: '100%', maxWidth: '400px' }}>
          <WideToggle
            options={[
              { label: t('stories.all-stories', 'All Stories*'), value: 0 },
              {
                label: t(['stories.family-stories', 'stories.completed'], {
                  fallbackLng: i18n.language, // TODO: use 'family-stories' in english & 'completed' as fallback till other lngs are translated, remove this later
                  defaultValue: 'Family Stories*',
                }),
                value: 1,
              },
            ]}
            ariaLabel={t('stories.select-mode', 'Select Mode')}
            selectedValue={activePersonId ? 1 : 0}
            onSelect={(selection) => {
              const valueToDispatch = selection.value ? cisId : ''
              onActivePersonIdChange(valueToDispatch)
            }}
          />
        </div>
      </div>
      <Separator size="sm" />
      <div style={{ position: 'relative', zIndex: 1 }}>
        <PointsNStreakRow
          isStreakCurrent={isStreakCurrent}
          streakCount={streakCount}
          points={points}
          onStreakClick={onStreakClick}
          onPointsClick={onPointsClick}
          isSmallScreen
        />
      </div>
      <div
        style={{
          transform: 'scale(.9)',
          position: 'relative',
          marginTop: '-40px',
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <UserPortraitSelector />
      </div>
    </div>
  )
}

SmallStoryHeaderContent.propTypes = {
  onActivePersonIdChange: func.isRequired,
  streakCount: number,
  points: number,
  isStreakCurrent: bool,
  onStreakClick: func.isRequired,
  onPointsClick: func.isRequired,
  activePersonId: oneOfType([string, bool]),
  cisId: string,
}
